import React from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { HelpCircle, X } from 'lucide-react';
import { useKB } from './KBContext';

const QuickGuideModal = ({ show, onClose }) => {
  const { memberInfo } = useKB();
  const isAdmin = !memberInfo;  // members (magic-link) are read-only
  return (
  <AnimatePresence>
    {show && (
      <motion.div className="kb-disclaimer-overlay" onClick={onClose}
        initial={{ opacity: 0 }} animate={{ opacity: 1 }} exit={{ opacity: 0 }}
        data-testid="kb-guide-overlay">
        <motion.div className="kb-disclaimer-modal kb-guide-modal" onClick={(e) => e.stopPropagation()}
          initial={{ opacity: 0, scale: 0.95 }} animate={{ opacity: 1, scale: 1 }} exit={{ opacity: 0, scale: 0.95 }}
          data-testid="kb-guide-modal">
          <div className="kb-disclaimer-header">
            <HelpCircle size={18} />
            <h3>Quick Guide — IPMI Document Intelligence</h3>
            <button className="kb-disclaimer-close" onClick={onClose} data-testid="kb-guide-close">
              <X size={18} />
            </button>
          </div>
          <div className="kb-disclaimer-body kb-guide-body">
            <h4>Ask Questions (Chat Tab)</h4>
            <p>Type any question about IPMI documents in the chat box. The AI searches across all ingested documents and provides answers with source citations. Use the quick-start buttons for common queries.</p>

            <h4>Browse Documents (Documents Tab)</h4>
            <p>View all documents in a searchable, filterable library. Use the sidebar filters for <strong>Categories</strong>, <strong>Years</strong>, <strong>File Types</strong>, and <strong>Key Topics</strong>. Click any document card to view its full details.</p>

            {isAdmin && (
              <>
                <h4>Edit Document Metadata</h4>
                <ol>
                  <li>Open a document from the Documents tab</li>
                  <li>Click <strong>Edit</strong> (top right)</li>
                  <li>Modify any field: title, summary, authors, organizations, category, year, conference/event, key topics, or tags</li>
                  <li>Click <strong>Save</strong> and enter your name for the audit trail</li>
                  <li>Changes are live immediately</li>
                </ol>
                <p>Use <strong>Regenerate with AI</strong> to have the AI re-analyze a document from scratch.</p>

                <h4>Conference / Event Tagging</h4>
                <p>Each document can be tagged with its source conference or event (e.g., "IPMI Annual Conference", "Student Awards"). Set this in Edit mode using the Conference/Event dropdown.</p>
              </>
            )}

            <h4>Download Documents</h4>
            <p>Click <strong>Download</strong> on any document card or detail view to get the original file from the archive.</p>

            {isAdmin && (
              <>
                <h4>Upload &amp; Sync Documents</h4>
                <p>New documents are uploaded to the R2 storage bucket, then synced into the platform. Click the <strong>sync icon</strong> next to "Documents" in the sidebar, or use the <strong>Admin panel</strong> (gear icon) to access the full upload and sync tools. After syncing, the AI automatically generates summaries, tags, and metadata for each new document.</p>
              </>
            )}

            <h4>Report Issues</h4>
            <p>Use <strong>Report a problem</strong> or <strong>Have a suggestion?</strong> at the bottom of the Chat tab to send feedback directly to the admin team.</p>
          </div>
        </motion.div>
      </motion.div>
    )}
  </AnimatePresence>
  );
};

export default QuickGuideModal;
